export const API_BASE_URL = "https://api20250612075426-bbf9afhghxc0gdhm.southeastasia-01.azurewebsites.net";
//export const API_BASE_URL = "https://localhost:7096";

